























































// vue
import { Component, Vue } from 'vue-property-decorator'

// componnents
import { PageHeader, ButtonExport } from '@/components'
import { TableListItemDailyControls, FilterDailyControl } from '@/components/dailyControl'

// services
import { DailyControlsService } from '@/services/dailyControl'
import { WorkDescriptionService, EmployeeService } from '@/services/config'

// utils
import { loading, alerts, getFullNameFormat } from '@/utils'
import { formatDate } from '@/utils/dateLibs'

// models
import { DailyControlForm, DailyControlModel, FiltersDailyControlModel } from '@/models/dailyControl'
import { WorkDescriptionModel, EmployeeModel } from '@/models/config'
import { BvModalEvent } from 'bootstrap-vue'

// views
import ModalCreateEditDailyControl from './modalCreateEdit.vue'

const newItem: DailyControlForm = {
  price: 0,
  date: '',
  employee_id: null,
  work_description_id: null,
  amount: 0,
  total: 0
}

@Component({
  name: 'DailyControlsIndex',
  components: {
    PageHeader,
    TableListItemDailyControls,
    ModalCreateEditDailyControl,
    FilterDailyControl,
    ButtonExport
  }
})
export default class DailyControlsIndex extends Vue {
  showModal = false
  dailyControl: DailyControlForm = newItem
  workDescriptions: WorkDescriptionModel[] = []
  employees: EmployeeModel[] = []
  title = 'Control Diario'
  actionForm = 'save'
  idItemEdit: number|null = null
  filters: FiltersDailyControlModel = {
    employee_id: '',
    workDescription_id: '',
    date_init: '',
    date_end: ''
  }

  allDailyControls: DailyControlModel[] = []
  headersExcel = [
    {
      value: 'employee',
      text: 'Empleado'
    },
    {
      value: 'workDescription',
      text: 'Descripción de Trabajo'
    },
    {
      value: 'price',
      text: 'Tarifa'
    },
    {
      value: 'amount',
      text: 'Cantidad'
    },
    {
      value: 'total',
      text: 'Importe'
    },
    {
      value: 'date',
      text: 'Fecha'
    }
  ]

  items = [
    {
      text: 'Dashboard',
      to: { name: 'home' }
    },
    {
      text: 'Control Diario',
      active: true
    }
  ]

  created () {
    this.getAll()
  }

  search () {
    setTimeout(() => {
      this.tableList.getDailyControlsWithPagination()
    }, 200)
  }

  changeFilters (filters: FiltersDailyControlModel) {
    this.filters = filters
  }

  async getAll () {
    this.employees = await EmployeeService.getActivated()
    this.workDescriptions = await WorkDescriptionService.getActivated()
  }

  async getAllitems () {
    this.allDailyControls = await DailyControlsService.getAll(this.filters)
    return this.allDailyControls
  }

  hideModal (event: BvModalEvent) {
    if (event.trigger !== 'ok') {
      this.showModal = false
    }
  }

  addNew () {
    this.idItemEdit = null
    this.actionForm = 'save'
    this.dailyControl = newItem
    this.showModal = true
  }

  editItem (item: DailyControlModel) {
    this.dailyControl = {
      price: item.price,
      date: item.date,
      employee_id: item.employee.id ?? null,
      work_description_id: item.work_description_id,
      amount: item.amount,
      total: item.total
    }
    if (item.id) {
      this.idItemEdit = Number(item.id)
    }
    this.actionForm = 'update'
    this.showModal = true
  }

  async deleteItem (item: DailyControlModel) {
    const msg = `Seguro que desea eliminar el Control Diario del Empleado: ${item.employee.name} ${item.employee.last_name}`
    const confirm = await alerts.confirm(msg)
    if (confirm && item.id) {
      loading('show')
      await DailyControlsService.delete(item.id)
      alerts.success()
      this.tableList.getDailyControlsWithPagination()
      loading('hide')
    }
  }

  get tableList (): Vue & { getDailyControlsWithPagination: () => void } {
    return this.$refs.table_list as Vue & { getDailyControlsWithPagination: () => void }
  }

  get itemInit (): DailyControlForm {
    return newItem
  }

  get itemsExcel () {
    return this.allDailyControls.map(daily => {
      return {
        employee: getFullNameFormat(daily.employee),
        workDescription: daily.workDescription.name,
        price: `S/ ${daily.price}`,
        amount: daily.amount,
        total: `S/ ${daily.total}`,
        date: formatDate(daily.date)
      }
    })
  }
}
